enum EventType {
  bankSlipCopy = 'boleto-copy',
  checkoutDismissed = 'checkout-dismissed',
  checkoutError = 'checkout-error',
  checkoutReady = 'checkout-ready',
  checkoutSuccess = 'checkout-success',
  emv3dsChallengeSuppression = '3ds-challenge-suppression',
  emv3dsDisabled = '3ds-disabled',
  emv3dsError = '3ds-error',
  emv3dsFailure = '3ds-failure',
  emv3dsReady = '3ds-ready',
  emv3dsSuccess = '3ds-success',
  emv3dsUnenrolled = '3ds-unenrolled',
  emv3dsUnsupportedBrand = '3ds-unsupported-brand',
  pixCopy = 'pix-copy',
  speiCopy = 'spei-copy',
  pagoEfectivoCopy = 'pago-efectivo-copy',
}

export default EventType
